import { useEffect, useRef, useState } from "react"

export const useGetScrollWidth = () => {
  const [scrollX, setScrollX] = useState<number | string>('100%')
  const lastScrollLeft = useRef<number>(0);
  
  const handleScroll = (e:React.UIEvent<HTMLDivElement>) => {
     const currentScrollLeft = e.currentTarget.scrollLeft;
    if(currentScrollLeft !== lastScrollLeft.current) {
      setScrollX(e.currentTarget.scrollWidth)
      lastScrollLeft.current = currentScrollLeft;
    }
    }
  
    return {
      scrollX,
      handleScroll
    }
  }

export const useGetIsResponsiveScreen = (maxWidth: string) => {
  const [isResponsive, setIsResponsive] = useState<boolean>(() =>
    window.matchMedia(maxWidth).matches
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(maxWidth)

    const handleChange = (event: MediaQueryListEvent) => {
      setIsResponsive(event.matches)
    }

    setIsResponsive(mediaQuery.matches)

    mediaQuery.addEventListener('change', handleChange)

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [maxWidth])

  return { isResponsive }
}